import { faUserAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Theme, Typography, useMediaQuery } from '@mui/material';

export function UserName({ userName }: { userName: string }) {
  const smDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const lgUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'));

  return (
    <Typography component="div">
      {mdDown ? null : (
        <>
          <FontAwesomeIcon icon={faUserAlt} size="1x" fixedWidth />
          <span>{userName}</span>
        </>
      )}

      {smDown || lgUp ? null : (
        <FontAwesomeIcon icon={faUserAlt} size="1x" fixedWidth />
      )}
    </Typography>
  );
}
